/**
 * KidSuper: first-paint decision for the sticky add-to-cart bar.
 *
 * sticky-add-to-cart.js is a module, so it cannot run until the whole page has parsed and its
 * import chain has downloaded; on a phone that is seconds after the product is on screen. This
 * classic script is preloaded from the head (snippets/scripts.liquid), placed at the end of
 * sections/product-information.liquid (after the buy buttons it measures) and runs
 * synchronously during parsing: if the buy buttons are already off screen (or within the same 30px
 * edge threshold the module uses), it switches the bar on immediately. The module reads
 * data-stuck when it connects and takes over from there.
 *
 * On reload and back/forward the browser restores the previous scroll position after this
 * runs, so showing the bar here could be undone ~150ms later (a visible flicker). To still be
 * quick in the common case, the scroll position is saved to sessionStorage on pagehide, keyed
 * by path: a reload or back/forward to a page that was left near the top is treated like a
 * fresh navigation; one left further down (or with no record) leaves the decision to the
 * module's after-load check. #hash navigations always wait.
 */
(function () {
  var THRESHOLD = 30;
  var STORAGE_KEY = 'kidsuper:sticky-scroll';
  var ns = (window.KidSuper = window.KidSuper || {});

  var readScroll = function () {
    var wrapper = document.querySelector('.page-wrapper');
    return Math.max(window.scrollY || 0, (wrapper && wrapper.scrollTop) || 0);
  };
  window.addEventListener('pagehide', function () {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ path: window.location.pathname, y: readScroll() }));
    } catch (e) {}
  });

  var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var type = nav && nav.type;
  var result = { at: Math.round(performance.now()), navigationType: type || null, shown: false };
  ns.stickyEarly = result;
  if (window.location.hash !== '') return;

  if (type === 'reload' || type === 'back_forward') {
    var saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    } catch (e) {}
    var leftNearTop = saved && saved.path === window.location.pathname && saved.y <= THRESHOLD;
    result.savedScroll = saved && saved.path === window.location.pathname ? saved.y : null;
    if (!leftNearTop) return;
  }

  var sticky = document.querySelector('sticky-add-to-cart');
  var bar = sticky && sticky.querySelector('[ref="stickyBar"]');
  var section = sticky && sticky.closest('.shopify-section');
  var buyButtons = section && section.querySelector('.buy-buttons-block');
  result.found = { bar: !!bar, buyButtons: !!buyButtons };
  if (!bar || !buyButtons) return;

  var rect = buyButtons.getBoundingClientRect();
  var clear = rect.top >= THRESHOLD && rect.bottom <= window.innerHeight - THRESHOLD;
  result.rect = [Math.round(rect.top), Math.round(rect.bottom)];
  result.innerHeight = window.innerHeight;
  if (!clear) {
    bar.dataset.stuck = 'true';
    // ADA note 13: the bar renders inert while hidden; lift it now that it is on screen.
    bar.inert = false;
    result.shown = true;
  }
})();
